import { createContext, useContext } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeContextValue {
  /** What the user chose. `system` follows the operating system setting. */
  preference: ThemePreference;
  /** The theme actually applied right now. */
  resolvedTheme: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
}

/** localStorage key shared with the pre-paint script in index.html. */
export const THEME_STORAGE_KEY = 'intellschools.theme';

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext);
  if (!value) throw new Error('useTheme() must be used inside <ThemeProvider>.');
  return value;
}

/** Like useTheme() but returns null when no provider is mounted (for optional integrations). */
export function useOptionalTheme(): ThemeContextValue | null {
  return useContext(ThemeContext);
}
